/**
 * NotFound — /* catch-all page (F-108).
 *
 * Any unknown route previously silently rendered the marketing homepage,
 * making dead links indistinguishable from redirects. This page owns the
 * "we don't know that URL" moment with a station search + link home.
 */
import { useNavigate } from "react-router-dom";
import { NavBar } from "@/components/NavBar";
import { T } from "@/lib/theme";

export default function NotFound() {
  const nav = useNavigate();
  return (
    <div data-testid="notfound-page" style={{
      fontFamily: "'Inter',system-ui,sans-serif",
      background: "#fff", color: T.navy, minHeight: "100vh",
    }}>
      <NavBar dark={false} />
      <div style={{ maxWidth: 640, margin: "96px auto", padding: 24, textAlign: "center" }}>
        <div className="ws-num" style={{
          fontSize: "clamp(72px, 12vw, 128px)", fontWeight: 900,
          letterSpacing: "-0.04em", color: T.green, lineHeight: 1, marginBottom: 12,
        }}>404</div>
        <h1 style={{ fontSize: "clamp(24px, 3vw, 32px)", fontWeight: 700,
          margin: "0 0 12px", color: T.navy, letterSpacing: "-0.02em" }}>
          That page doesn&apos;t exist.
        </h1>
        <p style={{ fontSize: 16, color: T.muted, lineHeight: 1.6, margin: "0 auto 28px", maxWidth: 480 }}>
          The link may be broken, the page may have moved, or the URL was mistyped.
          Try one of these instead:
        </p>
        <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
          <button data-testid="notfound-home"
            onClick={() => nav("/")}
            style={{
              background: T.green, color: "#fff", border: "none",
              padding: "14px 26px", borderRadius: 999, cursor: "pointer",
              fontSize: 14, fontWeight: 700, fontFamily: "inherit",
            }}>
            ← Back to the homepage
          </button>
          <button data-testid="notfound-listen"
            onClick={() => nav("/listen")}
            style={{
              background: "transparent", color: T.navy,
              border: `1px solid ${T.border}`,
              padding: "14px 26px", borderRadius: 999, cursor: "pointer",
              fontSize: 14, fontWeight: 700, fontFamily: "inherit",
            }}>
            Browse all stations
          </button>
          <button data-testid="notfound-verified"
            onClick={() => nav("/verified")}
            style={{
              background: "transparent", color: T.navy,
              border: `1px solid ${T.border}`,
              padding: "14px 26px", borderRadius: 999, cursor: "pointer",
              fontSize: 14, fontWeight: 700, fontFamily: "inherit",
            }}>
            Verified certificates
          </button>
        </div>
      </div>
    </div>
  );
}
